module.exports = __webpack_public_path__ + "static/media/right-img.86870159.png";